import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import chartModel from "../../../models/charts/chart.model";
import 'CssFolder/chart.scss';
import languageModel from "../../../models/language.model";

export default function SalesPerformanceChartComponent() {

    let chart;
    let chartId = 'xychart';
    let root;
    let colSeries1;
    let colSeries2;
    let xAxis;
    let yAxis;
    let legend;
    let currency;

    function initChart(_data) {
        createChart();
        createAxes();
        createSeries();
        loadData(_data);
        createLegend();
        // Animate on when appear
        colSeries1.appear(1000, 100);
        colSeries2.appear(1000, 100);
    }

    function createChart() {
        root?.dispose(); // dispose any pre-existing roots
        root = am5.Root.new(chartId);

        root.setThemes([
            am5themes_Responsive.new(root),
            am5themes_Animated.new(root)
        ]);

        chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panX: false,
                panY: false,
                wheelX: "none",
                wheelY: "none",
                layout: root.verticalLayout,
                paddingTop: 20,
                paddingBottom: 0,
                paddingLeft: 15,
                paddingRight: 15,
            })
        );

        // Set chart colors
        chart.get("colors").set("colors", [
            am5.color(0x8194DE),
            am5.color(0x97D654)
        ]);
    }

    function createAxes() {
        xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "month",
                renderer: am5xy.AxisRendererX.new(root, {
                    cellStartLocation: 0.1,
                    cellEndLocation: 0.9,
                    minGridDistance: 30
                })
            })
        );

        let xRenderer = xAxis.get("renderer");

        xRenderer.labels.template.setAll({
            fontSize: 12,
        });

        xRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                min: 0,
                maxPrecision: 0,
                renderer: am5xy.AxisRendererY.new(root, {})
            })
        );

        let yRenderer = yAxis.get("renderer");

        yRenderer.labels.template.setAll({
            fontSize: 12,
        });

        yRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

        if (currency) {
            // yAxis.axisHeader.children.unshift(am5.Label.new(root, {
            chart.children.unshift(am5.Label.new(root, {
                text: languageModel.getText("LT00000282", "Currency") + `: ${currency}`,
                x: 0,
                y: 0,
                // centerX: am5.p50,
                // marginLeft: -35,
                fontSize: 12,
                fontWeight: 500,
            }))
        }
    }

    function createSeries() {
        // First Series
        colSeries1 = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                // name: "Target" + (currency ? ` (${currency})` : ''),
                name: languageModel.getText("LT00000283", "Target"),
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "targetAmt",
                categoryXField: "month"
            })
        );

        colSeries1.columns.template.setAll({
            // tooltipText: "{categoryX}: {valueY}",
            tooltipText: "{valueY}",
            pointerOrientation: "horizontal",
            width: am5.percent(100),
        });

        colSeries1.data.processor = am5.DataProcessor.new(root, {
            numericFields: ["targetAmt"]
        });

        // Second Series
        colSeries2 = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                // name: "Actual" + (currency ? ` (${currency})` : ''),
                name: languageModel.getText("LT00000284", "Actual"),
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "actualAmt",
                categoryXField: "month"
            })
        );

        colSeries2.columns.template.setAll({
            // tooltipText: "{categoryX}: {valueY} | {achievement}%",
            tooltipText: "{valueY}",
            pointerOrientation: "horizontal",
            width: am5.percent(100),
        });

        colSeries2.data.processor = am5.DataProcessor.new(root, {
            numericFields: ["actualAmt"]
        });
    }

    function loadData(_data) {
        // Populate data
        for (var i = 1; i < _data.length; i++) {
            _data[i].valuePrev = _data[i - 1].actualAmt;
        }

        // load data to xAxis
        xAxis.data.setAll(_data);

        // load data to column series 1
        colSeries1.data.setAll(_data);

        // load data to column series 2
        colSeries2.data.setAll(_data);
    }

    function createLegend() {
        legend = chart.children.push(
            am5.Legend.new(root, {
                x: am5.percent(50),
                centerX: am5.percent(50),
                layout: root.horizontalLayout
            })
        );

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });

        legend.data.setAll(chart.series.values);
    }

    return {
        oninit: function (vnode) {
            chartId += chartModel.generateID();
        },
        oncreate: function (vnode) {
            if (vnode.attrs.data) {
               // console.log('vnode.attrs.data: ', vnode.attrs.data);
                if (vnode.attrs.data.length > 0 && vnode.attrs.data[0].currency) {
                    currency = vnode.attrs.data[0].currency;
                }
                initChart(vnode.attrs.data);
            }
        },
        view: function (vnode) {
            return m('.chart', {
                id: chartId,
            });
        }
    }
}